import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
const state = {
    activeLcName: "", // 当前选中林场名称
    rightPopState: false, // 右侧功能栏状态
    urlIp: "", // 当前部署网络地址(到项目名)
    tableNameLt: "", // 落图图斑表名
    shbTuBan: "", // 塞罕坝局部图斑图层
    isSubScene: false, // 是否为子场景
    showMode: 0, // 当前展示模式  0全景漫游 1导览
    // 当前场景显示渲染状态
    isShowCanvas: true,
    // 判断是否登录
    ticket: "",
    // 展示视频数据
    videoList: [],
    // 落地图斑字段翻译
    ltFY: [],
    // 当前选中专题模块
    ztActiveName: "",
    // 景区导览状态
    scenicGuideState: false,
    // 自定义统计界面
    customTJ: false,
    // 统计报表界面
    reportTJ: false,
    // 三维勾绘编辑界面
    showXbEdit: false,
    // 三维勾绘开启状态
    isToDraw: false,
    // 当前全景图片地址
    qjUrl: "",
    // 加载中界面
    loading_state: true,
    // 头部计划或完成
    head_txt: "计划",
    // 点击专题展示表格时加载中
    loading_zt: false,
    // 右上角专题名称
    type: "林地地类",
    // 右上角专题图例
    lenged: [],
    legend_state: false,
    // 当前显示的区划
    quhua: [],
    quhua_code: "200000",
    arr_quhua: [],
    // 专题所有的年份
    year: [],
    // 专题激活年份
    active_year: "2022",
    // 当前激活对象
    active_obj: "",
    // 测量开关
    mea_state: false,
    // 专题树
    tree: [],
    // 保存勾选的落图图斑和林草图斑
    check_layer: [],
    // 右侧专题树状态
    zt_state: false,
    // 表格
    table_state: false,
    // 缩放级别
    zoom: 1,
    // 右下角图层状态
    layer_state: false,
    // 统计报表状态
    total_state: false,
    // 申报文件状态
    shb_state: false,
    // 图层控制列表
    tcList: [
        {
            id: 1,
            label: "影像",
            shuju: "",
            children: [{ id: 3, label: "影像数据", shuju: "", checked: true }]
        }
    ],
    sanwei: {
        // 内网或外网 false 外网 inner 内网
        type_data: false,
        // 右上角专题名称
        type: "林地地类",
        // 右上角专题图例
        lenged: [],
        legend_state: false,
        arr_quhua: [],
        // 当前显示的区划
        active_quhua: ["全国"],
        // 专题所有的年份
        year: [],
        // 专题激活年份
        active_year: "",
        // 测量开关
        mea_state: false,
        // 专题树
        tree: [],
        // 右侧专题树状态
        zt_state: false,
        // 表格
        table_state: false,
        // 图层控制列表
        tcList: [
            {
                id: 1,
                label: "影像",
                shuju: "",
                children: [
                    { id: 3, label: "影像数据", shuju: "", checked: true }
                ]
            },
            // {
            //     id: 2, label: "小班", shuju: "", children: [
            //         { id: 4, label: "小班数据", shuju: "", checked: false }
            //     ]
            // }
            {
                id: 5,
                label: "样地",
                shuju: "",
                children: [
                    { id: 6, label: "样地数据", shuju: "", checked: false }
                ]
            }
        ]
    }
};
const store = new Vuex.Store({
    state
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js